import * as React from "react";

// The rendered width of an element, kept current by a ResizeObserver: 0
// before the first measurement (so a server render and the narrowest
// layout agree). For layouts that depend on the space a page actually
// has -- which the viewport does not tell, with a sidebar beside it.
export function useElementWidth(ref: React.RefObject<HTMLElement | null>) {
  const [width, setWidth] = React.useState(0);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setWidth(el.clientWidth);
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    measure();
    return () => ro.disconnect();
  }, [ref]);

  return width;
}
